import DatePicker from '../../../component/dateTime';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import AppLayout from '../../../component/appLayout';
import {
  InvoiceDetailInterface,
  InvoiceItemsInterface,
  projectIdInterface
} from '../../../interfaces/InvoiceInterface';
import { createNewInvoice, getInvoiceId, getInvoiceViewData, updateInvoice } from '../../../services/invoiceService';
import {
  HeaderBlock,
  Heading,
  Icon,
  HeaderTitle,
  MainGroup,
  Group1,
  Row,
  Label,
  InputLabel,
  AnotherTex,
  NoTex,
  Group2,
  GroupHeader,
  RightHeader,
  Project,
  Quantity,
  Amount,
  Fields,
  InputArea,
  QuantityRate,
  AmountRate,
  AddButton,
  BottomField,
  Total,
  Subtotal,
  Name,
  Content,
  TotalAmount,
  TotalContent,
  Buttons,
  Group,
  Price,
  UnitRate,
  RowRightHeader,
  Checks,
  TaxOutside,
  Label1,
  RemoveIcon,
  Tax,
  DragIcon,
  ItemRow,
  ResponsiveLabel,
  OuterDiv,
  TableGroup,
  DeleteIcon,
  SortableWrapper,
  DragOverlayFields
} from './styles';
import { currencyWithDecimal, getUrlParam, isEmpty } from '../../../helpers/common';
import { CurrencyList, currencySymbols } from '../../../global/row';
import { useHistory, useParams } from 'react-router-dom';
import { getCustomerProjectDetail, getIndividualCustomerDetail } from '../../../services/customerServices';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, ICON_SIZE, INVOICE_STATUS } from '../../../global/constants';
import dayjs from 'dayjs';
import Button from '../../../component/button';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import UserPreferenceSingleton from '../../../helpers/userPreferenceSingleton';
import { dispatchSettingError, getInvoicingSettingsData } from '../../../services/settingServices';
import { captureException } from '../../../services/logService';
import { trackAnalyticActivity } from '../../../services/analyticsService';
import {
  DndContext,
  DragOverlay,
  DragStartEvent,
  DragEndEvent,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { nanoid } from 'nanoid';
import { INVOICE_ANALYTICS } from '../../../global/analyticsConstants';
import { useMobileDevice } from '../../../global/useMobile';
import { Dropdown, DropdownItem } from '../../../component/dropdown';
import { CustomerProjectDetailInterface } from '../../../interfaces/CustomerInterface';
import ResponsiveHeader from '../../../component/responsiveHeader';
import BottomSubNavigation from '../../../component/bottomNavigation/subNavigation';
import BottomNavigationItem from '../../../component/bottomNavigation/subNavigation/bottomNavigationItem';
import IconButton from '../../../component/button/iconButton';
import Input from '../../../component/input';
import TextArea from '../../../component/input/textArea';
import CheckboxInput from '../../../component/input/checkboxInput';
import { ROUTES } from '../../../routes/urls';

interface SortableInvoiceItemProps {
  id: string;
  children: (dragHandleProps: Record<string, unknown>) => React.ReactNode;
}

const SortableInvoiceItem: React.FC<SortableInvoiceItemProps> = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
  const cssTransform = CSS.Translate.toString(transform ? { ...transform } : null) || undefined;

  return (
    <SortableWrapper
      ref={setNodeRef}
      isDragging={isDragging}
      cssTransform={cssTransform}
      cssTransition={transition || undefined}>
      {children({ ...attributes, ...listeners })}
    </SortableWrapper>
  );
};

const NewInvoiceSecondStep: React.FC = () => {
  //States
  const [loading, setLoading] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [searchProjectQueries, setSearchProjectQueries] = useState<Record<string, string>>({});
  const [isProjectDropdownOpen, setIsProjectDropdownOpen] = useState<Record<string, boolean>>({});
  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const [customerProjectDetail, setCustomerProjectDetail] = useState<CustomerProjectDetailInterface[]>([]);
  //Mobx state variables
  const { workspaceStore, invoiceStore } = rootStore;
  const { inputInvoiceDetail } = invoiceStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const workspace_id = workspace?.id || '';

  //Other variable
  const history = useHistory();
  const customerId = getUrlParam(history.location.search, 'customer');
  const params: { invoice_id: string } = useParams();
  const ref = currencySymbols.find((x) => x?.code === inputInvoiceDetail?.currency);
  const symbol = ref?.symbol;
  const taxFieldCount = inputInvoiceDetail.tax.length;
  const mobile = useMobileDevice();
  const [activeId, setActiveId] = useState<string | null>(null);
  const activeItem = useMemo(
    () => (activeId ? inputInvoiceDetail?.items?.find((item) => item?.id === activeId) : null),
    [activeId, inputInvoiceDetail?.items]
  );
  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));
  const sortableIds = useMemo(
    () => inputInvoiceDetail?.items?.map((item) => item?.id) || [],
    [inputInvoiceDetail?.items]
  );

  // set initial indexes for invoice items
  const setInitialIndexes = (invoiceItems: InvoiceItemsInterface[]) => {
    // Set indexes starting from 100, increasing by 100 for each item
    return invoiceItems?.map((item, idx) => {
      return { ...item, index: 100 + idx * 100 };
    });
  };

  // load initial data
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace_id) && customerId && !isEmpty(customerId)) {
        setLoading(true);
        await getIndividualCustomerDetail(customerId);
        const projectResult = await getCustomerProjectDetail(workspace_id, customerId);
        setCustomerProjectDetail(projectResult || []);
        if (isEmpty(inputInvoiceDetail?.id) || !inputInvoiceDetail?.id) {
          const invoicingDetails = await getInvoicingSettingsData(workspace_id);
          if (!isEmpty(invoicingDetails?.note))
            rootStore.invoiceStore.updateInvoiceDetail('notes', invoicingDetails?.note);
          if (!isEmpty(invoicingDetails?.tax) || invoicingDetails?.tax?.length > 0)
            rootStore.invoiceStore.updateInvoiceDetail('tax', invoicingDetails?.tax);
          if (invoicingDetails?.dueDays && invoicingDetails?.dueDays !== 0) {
            const formattedDate = dayjs(new Date()).format();
            rootStore.invoiceStore.updateInvoiceDetail('date', formattedDate);
            const formattedDueDate = isEmpty(inputInvoiceDetail?.dueDate)
              ? dayjs().add(invoicingDetails?.dueDays, 'day').format()
              : inputInvoiceDetail?.dueDate;
            rootStore.invoiceStore.updateInvoiceDetail('dueDate', formattedDueDate);
            rootStore.invoiceStore.updateInvoiceDetail('dueDays', invoicingDetails?.dueDays);
          }
          await getInvoiceId(!isEmpty(inputInvoiceDetail?.currency));
          if (inputInvoiceDetail?.items?.length > 0 && isEmpty(inputInvoiceDetail?.items[0]?.id)) {
            const newItems = inputInvoiceDetail?.items?.map((item) => {
              if (!isEmpty(item?.projectId)) {
                const project = projectResult?.find((ele: { id: projectIdInterface }) => ele?.id === item?.projectId);
                return { ...item, projectId: project };
              } else {
                return item;
              }
            });
            const itemsWithIndexes = setInitialIndexes(newItems);
            const sortedItems = itemsWithIndexes.toSorted((a, b) => (a?.index ?? 0) - (b?.index ?? 0));
            // Update the state
            rootStore.invoiceStore.updateInvoiceDetail('items', sortedItems);
          }
        } else {
          const newItems = inputInvoiceDetail?.items?.map((item) => {
            if (!isEmpty(item?.projectId)) {
              const project = projectResult?.find((ele: { id: projectIdInterface }) => ele?.id === item?.projectId);
              return { ...item, projectId: project };
            } else {
              return item;
            }
          });
          rootStore.invoiceStore.updateInvoiceDetail('emails', []);
          const itemsWithIndexes = setInitialIndexes(newItems);
          const sortedItems = itemsWithIndexes.toSorted((a, b) => (a?.index ?? 0) - (b?.index ?? 0));
          rootStore.invoiceStore.updateInvoiceDetail('items', sortedItems);
        }
        if (params?.invoice_id) {
          const response: [InvoiceDetailInterface, CustomerProjectDetailInterface] = await Promise.all([
            getInvoiceViewData(params?.invoice_id),
            getCustomerProjectDetail(workspace_id, customerId)
          ]);
          let invoiceData: InvoiceDetailInterface = response[0];
          if (response[0]?.items && response[0]?.items) {
            const updatedItems: InvoiceItemsInterface[] = invoiceData?.items?.map((item: InvoiceItemsInterface) => {
              if (item?.projectId) {
                const project = projectResult?.find((ele: { id: projectIdInterface }) => ele?.id === item?.projectId);
                return { ...item, projectId: project };
              } else {
                return item;
              }
            });
            invoiceData = { ...invoiceData, items: updatedItems };
          }
          rootStore.invoiceStore.setInvoiceDetail(invoiceData);
        }
      }
    } catch (error) {
      captureException(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspace_id, customerId, params?.invoice_id, inputInvoiceDetail?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    return () => {
      rootStore.invoiceStore.clearInvoiceDetail();
    };
  }, []);

  // calculate total amount logic
  const calculateTotalAmount = useCallback(async (invoiceInput: InvoiceDetailInterface) => {
    let subTotal = invoiceInput?.items?.reduce((sum: number, val) => sum + Number(val?.amount || 0), 0);
    let totalDiscount = (subTotal * Number(invoiceInput?.discount)) / 100;
    let totalTax = 0;
    let totalTax2 = 0;
    invoiceInput?.items?.forEach((item) => {
      let discountedAmount = Number(item?.amount) - (Number(item?.amount) * Number(invoiceInput?.discount)) / 100;
      if (item?.isTax && invoiceInput?.tax[0]?.value > 0) {
        totalTax = totalTax + (Number(discountedAmount) * Number(invoiceInput?.tax[0]?.value)) / 100;
      }
      if (item?.isTax2 && invoiceInput?.tax[1]?.value > 0) {
        totalTax2 = totalTax2 + (Number(discountedAmount) * Number(invoiceInput?.tax[1]?.value)) / 100;
      }
    });
    let totalAmount = Number(subTotal) - Number(totalDiscount) + Number(totalTax) + Number(totalTax2);
    invoiceInput = { ...invoiceInput, subTotal, totalDiscount, totalTax, totalTax2, totalAmount };
    rootStore.invoiceStore.setInvoiceDetail(invoiceInput);
  }, []);

  // handle input field change
  const onChangeInputField = useCallback(
    async (propsName: string, value: string) => {
      let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
      invoiceInput[propsName] = value;
      rootStore.invoiceStore.updateInvoiceDetail(propsName, value);
      await calculateTotalAmount(invoiceInput);
    },
    [inputInvoiceDetail, calculateTotalAmount]
  );

  // manage tax input field
  const onChangeTaxInputField = useCallback(
    async (index: number, value: string) => {
      let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
      let tax = invoiceInput?.tax;
      if (index === 0) {
        tax[0] = { ...tax[0], value: value };
      } else if (index === 1) {
        tax[1] = { ...tax[1], value: value };
      }
      invoiceInput.tax = tax;
      rootStore.invoiceStore.updateInvoiceDetail('tax', tax);
      await calculateTotalAmount(invoiceInput);
    },
    [inputInvoiceDetail, calculateTotalAmount]
  );

  // manage items input field
  const onChangeItemsInputField = useCallback(
    (index: number, propsName: string, value: string | number | boolean) => {
      let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
      let items = invoiceInput?.items;
      items[index][propsName] = value;
      if (propsName === 'qty') {
        items[index]['amount'] = Number(value || 0) * items[index].unitPrice;
      } else if (propsName === 'unitPrice') {
        items[index]['amount'] = Number(value || 0) * items[index].qty;
      }
      invoiceInput.items = items;
      rootStore.invoiceStore.updateInvoiceDetail('items', items);
      if (propsName === 'isTax' || propsName === 'isTax2' || propsName === 'qty' || propsName === 'unitPrice') {
        calculateTotalAmount(invoiceInput);
      }
    },
    [inputInvoiceDetail, calculateTotalAmount]
  );

  // Update search query for a specific item
  const onChangeSearch = useCallback((itemId: string, value: string) => {
    setIsSearch(true);
    setSearchProjectQueries({});
    setSearchProjectQueries(() => ({
      [itemId]: value // Store search query per item
    }));
  }, []);

  const handleProjectDropdownOpenChange = useCallback((itemId: number, isOpen: boolean) => {
    setIsProjectDropdownOpen((prevState) => ({ ...prevState, [itemId]: isOpen }));
  }, []);

  // manage items input field
  const onChangeProject = useCallback(
    (index: number, propsName: string, value: object) => {
      let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
      let items = invoiceInput?.items;
      items[index][propsName] = value;
      invoiceInput.items = items;
      // Set search query for this item based on selected project
      setIsSearch(false);
      rootStore.invoiceStore.updateInvoiceDetail('items', items);
    },
    [inputInvoiceDetail]
  );

  // handle date change
  const onChangeDate = useCallback(
    (propsName: string, value: dayjs.Dayjs | null) => {
      rootStore.invoiceStore.updateInvoiceDetail(propsName, value ? value.format() : null);
      let timeDiff = 0;
      let dueDays = 0;
      if (propsName === 'date') {
        if (inputInvoiceDetail?.dueDate && value) {
          timeDiff = new Date(inputInvoiceDetail.dueDate).getTime() - value.toDate().getTime();
          dueDays = timeDiff / (1000 * 60 * 60 * 24);
        }
      } else if (propsName === 'dueDate') {
        if (inputInvoiceDetail?.date && value) {
          timeDiff = value.toDate().getTime() - new Date(inputInvoiceDetail.date).getTime();
          dueDays = timeDiff / (1000 * 60 * 60 * 24);
        }
      }
      rootStore.invoiceStore.updateInvoiceDetail('dueDays', !isEmpty(value) ? Math.round(dueDays) : 0);
    },
    [inputInvoiceDetail]
  );

  // handle add items
  const onAddItems = useCallback(async () => {
    let itemClone = JSON.parse(JSON.stringify(inputInvoiceDetail?.items));
    const currentItem = inputInvoiceDetail?.items?.length - 1;
    const currentIndex = inputInvoiceDetail?.items?.[currentItem]?.index;
    let Clone = {
      id: nanoid(),
      index: (currentIndex || 0) + 100,
      amount: 0,
      desc: '',
      isTax: true,
      isTax2: true,
      itemType: 1,
      projectId: '',
      qty: 1,
      unitPrice: 0
    };
    const newItems = [...itemClone, Clone];
    rootStore.invoiceStore.updateInvoiceDetail('items', newItems);
  }, [inputInvoiceDetail]);

  // handle create invoice
  const onCreateInvoice = useCallback(
    async (e: React.SyntheticEvent, value: number) => {
      try {
        e.preventDefault();
        setLoading(true);
        let itemsClone = JSON.parse(JSON.stringify(inputInvoiceDetail?.items));
        const userDetails = UserPreferenceSingleton.getInstance().getCurrentUser();
        itemsClone = itemsClone?.map((ele: InvoiceItemsInterface) => {
          return {
            ...ele,
            projectId: ele?.projectId?.id,
            qty: Number(ele?.qty),
            unitPrice: Number(ele?.unitPrice)
          };
        });
        if (itemsClone?.some((x: { amount: number }) => !x?.amount || x?.amount === 0)) {
          dispatchSettingError('Please enter valid amount for every items!');
          return;
        }
        if (itemsClone?.some((x: { desc?: string }) => !x?.desc)) {
          dispatchSettingError('Please add a description for every item!');
          return;
        }
        const allTaxes = inputInvoiceDetail?.tax?.map((ele) => {
          return {
            ...ele,
            value: Number(ele?.value)
          };
        });
        let payload;
        let response;
        if (!isEmpty(inputInvoiceDetail?.id)) {
          payload = {
            ...inputInvoiceDetail,
            items: itemsClone,
            status: INVOICE_STATUS.SAVE,
            userId: userDetails?.id,
            customerId: inputInvoiceDetail?.customer?.id,
            discount: Number(inputInvoiceDetail?.discount),
            tax: allTaxes
          };
          if (payload?.customer) delete payload?.customer;
          response = await updateInvoice(inputInvoiceDetail?.id, payload);
          if (response) {
            const { data } = response;
            trackAnalyticActivity(INVOICE_ANALYTICS.EDITED);
            rootStore.invoiceStore.clearInvoiceDetail();
            history.push(ROUTES.INVOICE_DETAILS.replace(':id', data['_id']));
          }
        } else {
          if (value === INVOICE_STATUS.DRAFT) {
            payload = {
              ...inputInvoiceDetail,
              items: itemsClone,
              status: INVOICE_STATUS.DRAFT,
              userId: userDetails?.id,
              customerId: inputInvoiceDetail?.customer?.id,
              discount: Number(inputInvoiceDetail?.discount),
              tax: allTaxes
            };
            if (payload?.customer) delete payload?.customer;
            response = await createNewInvoice(payload);
            if (response) {
              trackAnalyticActivity(INVOICE_ANALYTICS.CREATED);
              rootStore.invoiceStore.clearInvoiceDetail();
              history.push(ROUTES.INVOICES);
            }
          } else if (value === INVOICE_STATUS.SAVE) {
            payload = {
              ...inputInvoiceDetail,
              items: itemsClone,
              status: INVOICE_STATUS.SAVE,
              userId: userDetails?.id,
              customerId: inputInvoiceDetail?.customer?.id,
              discount: Number(inputInvoiceDetail?.discount),
              tax: allTaxes
            };
            if (payload?.customer) delete payload?.customer;
            response = await createNewInvoice(payload);
            if (response) {
              trackAnalyticActivity(INVOICE_ANALYTICS.CREATED);
              const { data } = response;
              rootStore.invoiceStore.clearInvoiceDetail();
              history.push(ROUTES.INVOICE_DETAILS.replace(':id', data?.data?.['_id'] || ''));
            }
          }
        }
      } catch (e) {
        captureException(e);
      } finally {
        setLoading(false);
      }
    },
    [inputInvoiceDetail, history]
  );

  // for apply tax to invoice
  const onAddTax = useCallback(async () => {
    let itemClone = JSON.parse(JSON.stringify(inputInvoiceDetail?.tax));
    let Clone;
    if (inputInvoiceDetail?.tax.length === 0) {
      Clone = {
        name: 'Tax',
        value: 0
      };
    } else {
      Clone = {
        name: 'Tax2',
        value: 0
      };
    }
    const newItems = [...itemClone, Clone];
    rootStore.invoiceStore.updateInvoiceDetail('tax', newItems);
  }, [inputInvoiceDetail]);

  // for delete item
  const deleteItem = useCallback(
    (index: number) => {
      let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
      let items = invoiceInput?.items;
      if (items?.length <= 1) {
        items = [
          {
            amount: 0,
            desc: '',
            isTax: true,
            isTax2: true,
            itemType: 1,
            projectId: '',
            qty: 1,
            unitPrice: 0
          }
        ];
      } else {
        items.splice(index, 1);
      }
      rootStore.invoiceStore.updateInvoiceDetail('items', items);
      invoiceInput.items = items;
      calculateTotalAmount(invoiceInput);
    },
    [inputInvoiceDetail, calculateTotalAmount]
  );

  // for delete tax form invoice
  const deleteTax = useCallback(() => {
    let invoiceInput = JSON.parse(JSON.stringify(inputInvoiceDetail));
    let tax = invoiceInput?.tax;
    tax.pop();
    rootStore.invoiceStore.updateInvoiceDetail('tax', tax);
    invoiceInput.tax = tax;
    calculateTotalAmount(invoiceInput);
  }, [inputInvoiceDetail, calculateTotalAmount]);

  //calculate the task index

  const handleDragStart = useCallback((event: DragStartEvent) => {
    setActiveId(event.active.id as string);
  }, []);

  const handleDragEnd = useCallback(
    (event: DragEndEvent) => {
      try {
        const { active, over } = event;
        setActiveId(null);
        if (!over || active.id === over.id) return;
        const items = inputInvoiceDetail?.items || [];
        const sourceIndex = items.findIndex((item) => item?.id === active.id);
        const destinationIndex = items.findIndex((item) => item?.id === over.id);
        if (sourceIndex === -1 || destinationIndex === -1) return;
        const reorderedItems = arrayMove([...items], sourceIndex, destinationIndex);
        const itemsWithUpdatedIndexes = reorderedItems.map((item, idx) => ({ ...item, index: 100 + idx * 100 }));
        rootStore.invoiceStore.updateInvoiceDetail('items', itemsWithUpdatedIndexes);
      } catch (error) {
        captureException(error);
      }
    },
    [inputInvoiceDetail?.items]
  );

  const handleCloseItemDropdown = useCallback(() => {
    setIsSearch(false);
    setSearchProjectQueries({});
  }, []);

  // render invoice tax detail
  const renderInvoiceTexDetail = useMemo(() => {
    return (
      <>
        {inputInvoiceDetail.tax.map((item, index) => (
          <Input
            label={item.name}
            min={0}
            step='any'
            placeHolder='0'
            type='number'
            value={item?.value}
            onChange={(e) => onChangeTaxInputField(index, e.target.value)}
            fieldWrapperWidth={mobile ? '100%' : '172px'}
          />
        ))}
        <TaxOutside>
          {inputInvoiceDetail?.tax?.length > 0 && (
            <NoTex role='button' onClick={deleteTax}>
              No tax
            </NoTex>
          )}
          {inputInvoiceDetail.tax.length < 2 && (
            <AnotherTex role='button' showBorder={inputInvoiceDetail?.tax?.length > 0} onClick={onAddTax}>
              {inputInvoiceDetail?.tax?.length < 1 ? '(Apply tax to invoice)' : 'Apply another tax'}
            </AnotherTex>
          )}
        </TaxOutside>
      </>
    );
  }, [inputInvoiceDetail.tax, deleteTax, onAddTax, mobile, onChangeTaxInputField]);

  const renderDeleteIcon = useCallback(
    (index: number) => {
      return (
        <IconButton
          iconName='updated-delete-icon'
          size={ICON_BUTTON_SIZE.SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={() => deleteItem(index)}
        />
      );
    },
    [deleteItem]
  );

  const renderItemRightColumns = useCallback(
    (item: InvoiceItemsInterface) => (
      <>
        <ItemRow>
          <QuantityRate type='number' value={item?.qty} readOnly />
        </ItemRow>
        <ItemRow>
          <UnitRate type='number' value={item?.unitPrice} readOnly />
        </ItemRow>
        {inputInvoiceDetail.tax.length > 0 && (
          <ItemRow>
            <Checks>
              <CheckboxInput checked={item?.isTax} />
            </Checks>
          </ItemRow>
        )}
        {inputInvoiceDetail.tax.length > 1 && (
          <ItemRow>
            <Checks>
              <CheckboxInput checked={item?.isTax2} />
            </Checks>
          </ItemRow>
        )}
        <ItemRow>
          <AmountRate>{currencyWithDecimal(item?.amount)}</AmountRate>
        </ItemRow>
      </>
    ),
    [inputInvoiceDetail.tax]
  );

  // render invoice detail item
  const renderInvoiceDetailItem = useMemo(() => {
    return inputInvoiceDetail?.items?.map((item, index: number) => {
      const searchText = searchProjectQueries[item?.id]?.trim().toLowerCase() || '';
      const isCurrentProjectDropdownOpen = !!isProjectDropdownOpen[index];

      const searchedLinkedProject: CustomerProjectDetailInterface[] = searchText
        ? customerProjectDetail?.filter((x) => x?.name?.trim().toLowerCase().includes(searchText))
        : customerProjectDetail;

      return (
        <SortableInvoiceItem key={item?.id} id={item?.id}>
          {(dragHandleProps) => (
            <Fields>
              <DragIcon {...dragHandleProps}>
                <SVGIcon
                  name='invoice-drag-icon'
                  width={ICON_SIZE.MD}
                  height={ICON_SIZE.MD}
                  viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
                  className='drag-icon'
                />
              </DragIcon>
              <ItemRow className='first-row'>
                <Label1>Item {index + 1}</Label1>
                {renderDeleteIcon(index)}
              </ItemRow>
              <InputArea
                type='text'
                placeholder='Add Description'
                value={item?.desc}
                onChange={(e) => onChangeItemsInputField(index, 'desc', e.target.value)}
              />
              <RowRightHeader>
                <ItemRow>
                  <ResponsiveLabel>Linked Project</ResponsiveLabel>
                  <Dropdown
                    modalTitle='Project'
                    isMinWidth={132}
                    updateDropdownOpen={(isOpen) => handleProjectDropdownOpenChange(index, isOpen)}
                    content={
                      <Input
                        placeHolder='Select Project'
                        value={isSearch ? searchProjectQueries[item?.id] : item?.projectId?.name || ''}
                        onChange={(e) => onChangeSearch(item?.id, e.target.value)}
                        className='input-field'
                        fieldWrapperWidth={mobile ? '142px' : '138px'}
                        trailingIconName='down-arrow-icon'
                        trailingIconClassName={`angleDown-icon ${isCurrentProjectDropdownOpen ? 'rotate' : ''}`}
                      />
                    }
                    trigger='click'
                    onOutsideClick={handleCloseItemDropdown}>
                    {searchedLinkedProject.map((projectItem) => (
                      <DropdownItem
                        key={projectItem.key}
                        label={projectItem.name}
                        onClick={() => onChangeProject(index, 'projectId', projectItem)}
                      />
                    ))}
                  </Dropdown>
                </ItemRow>
                <ItemRow>
                  <ResponsiveLabel>Quantity</ResponsiveLabel>
                  <QuantityRate
                    type='number'
                    min={0}
                    step='any'
                    placeholder='1'
                    value={item?.qty}
                    onChange={(e) => onChangeItemsInputField(index, 'qty', e.target.value)}
                  />
                </ItemRow>
                <ItemRow>
                  <ResponsiveLabel>Unit Price</ResponsiveLabel>
                  <UnitRate
                    type='number'
                    min={0}
                    step='any'
                    placeholder='0.00'
                    value={item?.unitPrice}
                    onChange={(e) => onChangeItemsInputField(index, 'unitPrice', e.target.value)}
                  />
                </ItemRow>
                {inputInvoiceDetail.tax.length > 0 && (
                  <ItemRow>
                    <ResponsiveLabel>{inputInvoiceDetail.tax[0]?.name}</ResponsiveLabel>
                    <Checks>
                      <CheckboxInput
                        checked={item?.isTax}
                        onChange={() => onChangeItemsInputField(index, 'isTax', !item?.isTax)}
                      />
                    </Checks>
                  </ItemRow>
                )}
                {inputInvoiceDetail.tax.length > 1 && (
                  <ItemRow>
                    <ResponsiveLabel>{inputInvoiceDetail.tax[1]?.name}</ResponsiveLabel>
                    <Checks>
                      <CheckboxInput
                        checked={item?.isTax2}
                        onChange={() => onChangeItemsInputField(index, 'isTax2', !item?.isTax2)}
                      />
                    </Checks>
                  </ItemRow>
                )}
                <ItemRow>
                  <ResponsiveLabel>Amount</ResponsiveLabel>
                  <AmountRate>{currencyWithDecimal(item?.amount)}</AmountRate>
                </ItemRow>
              </RowRightHeader>
              {!mobile && <DeleteIcon>{renderDeleteIcon(index)}</DeleteIcon>}
            </Fields>
          )}
        </SortableInvoiceItem>
      );
    });
  }, [
    inputInvoiceDetail?.items,
    inputInvoiceDetail.tax,
    searchProjectQueries,
    isProjectDropdownOpen,
    customerProjectDetail,
    renderDeleteIcon,
    isSearch,
    mobile,
    handleCloseItemDropdown,
    onChangeItemsInputField,
    handleProjectDropdownOpenChange,
    onChangeSearch,
    onChangeProject
  ]);

  return (
    <>
      <AppLayout>
        <OuterDiv className='desktop-content'>
          {/* responsive header ui */}
          {mobile && (
            <ResponsiveHeader
              subTitle={inputInvoiceDetail?.number || ''}
              title={inputInvoiceDetail?.customer?.companyName || ''}
            />
          )}
          <Group>
            {/* web header ui */}
            {!mobile && (
              <HeaderBlock>
                <Heading>
                  <Icon>
                    <SVGIcon
                      name='invoice-icon'
                      width={ICON_SIZE.LG}
                      height={ICON_SIZE.LG}
                      viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                      className='invoice-icon'
                    />
                  </Icon>
                  <HeaderTitle>Invoice for {inputInvoiceDetail?.customer?.companyName}</HeaderTitle>
                </Heading>
                {isEmpty(inputInvoiceDetail?.id) && (
                  <Button
                    onClick={(e: React.SyntheticEvent) => onCreateInvoice(e, INVOICE_STATUS.DRAFT)}
                    title='Save as Draft'
                    variant={BUTTON_TYPE.SECONDARY}
                    size='small'
                    isLoading={loading}
                  />
                )}
              </HeaderBlock>
            )}
            <MainGroup onSubmit={(e) => onCreateInvoice(e, INVOICE_STATUS.SAVE)}>
              <Group1>
                <Row>
                  <Input
                    label='Invoice for'
                    placeHolder='Walter Melon'
                    value={inputInvoiceDetail?.customer?.companyName}
                    onChange={(e) => onChangeInputField('companyName', e.target.value)}
                    fieldWrapperWidth={mobile ? '100%' : '172px'}
                  />
                  <InputLabel>
                    <Label>Currency</Label>
                    <Dropdown
                      modalTitle='Currency'
                      isMinWidth={230}
                      dropdownContentWidth={mobile ? '100%' : '172px'}
                      updateDropdownOpen={setIsCurrencyDropdownOpen}
                      content={
                        <Input
                          placeHolder={inputInvoiceDetail?.currency ? inputInvoiceDetail.currency : 'Select Currency'}
                          value={inputInvoiceDetail?.currency}
                          trailingIconName='down-arrow-icon'
                          trailingIconClassName={`angleDown-icon ${isCurrencyDropdownOpen ? 'rotate' : ''}`}
                        />
                      }
                      trigger='click'>
                      {CurrencyList.map((item) => (
                        <DropdownItem
                          key={item.key}
                          label={item.value}
                          onClick={(e) => onChangeInputField('currency', item.key)}
                        />
                      ))}
                    </Dropdown>
                  </InputLabel>
                  <Input
                    label='Invoice Id'
                    placeHolder='TUT/2018-19/0011'
                    value={inputInvoiceDetail?.number}
                    onChange={(e) => onChangeInputField('number', e.target.value)}
                    readOnly={!isEmpty(inputInvoiceDetail?.id)}
                    fieldWrapperWidth={mobile ? '100%' : '172px'}
                  />
                  <InputLabel taxLength={inputInvoiceDetail.tax.length}>
                    <Label>Issue Date</Label>
                    <DatePicker
                      className='date-picker'
                      label='Enter the date'
                      value={inputInvoiceDetail?.date ? (new Date(inputInvoiceDetail.date) as Date) : null}
                      inputFormat='DD/MM/YYYY'
                      onChange={(date) => onChangeDate('date', date)}
                    />
                  </InputLabel>
                  <InputLabel taxLength={inputInvoiceDetail.tax.length}>
                    <Label>Due Date</Label>
                    <DatePicker
                      label='Enter the date'
                      value={inputInvoiceDetail?.dueDate ? new Date(inputInvoiceDetail.dueDate) : null}
                      inputFormat='DD/MM/YYYY'
                      onChange={(date) => onChangeDate('dueDate', date)}
                      className='date-picker'
                    />
                  </InputLabel>
                  <Input
                    min={0}
                    label='Discount'
                    type='number'
                    step='any'
                    placeHolder='0'
                    value={inputInvoiceDetail?.discount}
                    onChange={(e) => onChangeInputField('discount', e.target.value)}
                    fieldWrapperWidth={mobile ? '100%' : '172px'}
                  />
                  {renderInvoiceTexDetail}
                </Row>
              </Group1>
              <Group2>
                <TableGroup>
                  <GroupHeader>
                    <Label1>DESCRIPTION</Label1>
                    <RightHeader>
                      <Project>Linked Project</Project>
                      <Quantity>Qty</Quantity>
                      <Price>Unit Price</Price>
                      {inputInvoiceDetail?.tax.length > 0 && <Tax>{inputInvoiceDetail.tax[0]?.name} </Tax>}
                      {inputInvoiceDetail?.tax.length > 1 && <Tax>{inputInvoiceDetail.tax[1]?.name}</Tax>}
                      <Amount>Amount</Amount>
                      <RemoveIcon></RemoveIcon>
                    </RightHeader>
                  </GroupHeader>
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragStart={handleDragStart}
                    onDragEnd={handleDragEnd}>
                    <SortableContext items={sortableIds} strategy={verticalListSortingStrategy}>
                      {renderInvoiceDetailItem}
                    </SortableContext>
                    <DragOverlay>
                      {activeItem ? (
                        <DragOverlayFields isDragging>
                          <DragIcon>
                            <SVGIcon
                              name='invoice-drag-icon'
                              width={ICON_SIZE.MD}
                              height={ICON_SIZE.MD}
                              viewBox={`0 0 ${ICON_SIZE.MD} ${ICON_SIZE.MD}`}
                              className='drag-icon'
                            />
                          </DragIcon>
                          <InputArea type='text' value={activeItem?.desc} readOnly />
                          <RowRightHeader>
                            <ItemRow>
                              <Input
                                placeHolder='Select Project'
                                value={activeItem?.projectId?.name || ''}
                                fieldWrapperWidth={mobile ? '142px' : '138px'}
                                readOnly
                              />
                            </ItemRow>
                            {renderItemRightColumns(activeItem)}
                          </RowRightHeader>
                        </DragOverlayFields>
                      ) : null}
                    </DragOverlay>
                  </DndContext>
                </TableGroup>
                <AddButton>
                  <Button
                    variant={BUTTON_TYPE.SECONDARY}
                    title='Add Item'
                    iconName='plus-icon'
                    onClick={onAddItems}
                    iconPosition='start'
                  />
                </AddButton>
                <BottomField taxFieldCount={taxFieldCount}>
                  <TextArea
                    fieldWrapperWidth='100%'
                    placeHolder='Thanks for your business'
                    value={inputInvoiceDetail?.notes || ''}
                    onChange={(e) => onChangeInputField('notes', e.target.value)}
                  />
                  <Total>
                    <Subtotal>
                      <Name>Subtotal</Name>
                      <Content>
                        {symbol} {currencyWithDecimal(inputInvoiceDetail.subTotal)}
                      </Content>
                    </Subtotal>
                    <Subtotal>
                      <Name>Discount ({inputInvoiceDetail?.discount || 0}%)</Name>
                      <Content>
                        - {symbol} {currencyWithDecimal(inputInvoiceDetail?.totalDiscount)}
                      </Content>
                    </Subtotal>
                    {inputInvoiceDetail.tax.length > 0 && (
                      <Subtotal>
                        <Name>
                          {inputInvoiceDetail.tax[0]?.name} ({inputInvoiceDetail?.tax[0]?.value || 0}%)
                        </Name>
                        <Content>
                          {' '}
                          {symbol}
                          {currencyWithDecimal(inputInvoiceDetail?.totalTax)}
                        </Content>
                      </Subtotal>
                    )}
                    {inputInvoiceDetail.tax.length > 1 && (
                      <Subtotal>
                        <Name>
                          {inputInvoiceDetail.tax[1]?.name} ({inputInvoiceDetail?.tax[1]?.value || 0}%)
                        </Name>
                        <Content>
                          {' '}
                          {symbol}
                          {currencyWithDecimal(inputInvoiceDetail?.totalTax2)}
                        </Content>
                      </Subtotal>
                    )}
                    <TotalAmount>
                      <Name>Amount Due: </Name>
                      <TotalContent>
                        {symbol} {currencyWithDecimal(inputInvoiceDetail?.totalAmount)}
                      </TotalContent>
                    </TotalAmount>
                  </Total>
                </BottomField>
              </Group2>
              <Buttons>
                <Button
                  title={isEmpty(inputInvoiceDetail?.id) ? 'Create' : 'Update'}
                  variant={BUTTON_TYPE.PRIMARY}
                  isLoading={loading}
                  buttonType='submit'
                />
              </Buttons>
            </MainGroup>
          </Group>
        </OuterDiv>
      </AppLayout>
      <BottomSubNavigation
        rightElement={
          <BottomNavigationItem
            iconName='save-invoice-icon'
            onClick={(e: React.SyntheticEvent) => onCreateInvoice(e, INVOICE_STATUS.DRAFT)}
          />
        }
      />
    </>
  );
};

export default observer(NewInvoiceSecondStep);
